import { useState, useEffect } from "react";
import { useNotification } from "../../context/NotificationContext";
import { NotificationType } from "../../enums/NotificationType";

export default function Notification ({ type, message }) {

    const { notification, clearNotification } = useNotification();
    const [isShown, setIsShown] = useState(true);

    useEffect(() => {
        if (notification) {
          setIsShown(true);
    
          //Hide notification after 3 seconds
          const timer = setTimeout(() => {
            setIsShown(false);
            clearNotification();
          }, 3000);
    
          return () => clearTimeout(timer);
        }
      }, [notification, clearNotification]);
    
      const handleClose = () => {
        setIsShown(false);
        clearNotification();
      };

      const getIcon = () => {
        switch (notification?.type) {
            case NotificationType.Success:
                return 'check_circle';
            case NotificationType.Error:
                return 'error';
            case NotificationType.Info:
                return 'info';
            default:
                return '';
        }
    };

    return (
        isShown && notification && (
          <div className={`notification ${notification.type}`}>
            <span className="material-symbols-outlined">{getIcon()}</span>
            <p>{notification.message}</p>
            <span
              id="notification-close"
              className="material-symbols-outlined"
              onClick={handleClose}
            >
              close
            </span>
          </div>
        )
      );
    }